export var types = {
    LOGIN_SUCCESS: 'LOGIN_SUCCESS',
    LOGIN_ERROR: 'LOGIN_ERROR',
    AUTHENTICATING: 'AUTHENTICATING',
    LOGGING_OUT: 'LOGGING_OUT',
    LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
    LOGOUT_ERROR: 'LOGOUT_ERROR',
    AUTHORIZE_WITH_TOKEN: 'AUTHORIZE_WITH_TOKEN',
};
export var authorizeWithToken_AC = function (token) {
    return {
        type: types.AUTHORIZE_WITH_TOKEN,
        payload: {
            token: token,
        },
    };
};
export var logoutError_AC = function () {
    return {
        type: types.LOGOUT_ERROR,
    };
};
export var logoutSuccess_AC = function () {
    return {
        type: types.LOGOUT_SUCCESS,
    };
};
export var loggingOut_AC = function () {
    return {
        type: types.LOGGING_OUT,
    };
};
export var loginSuccess_AC = function (token, userId, login, apps) {
    return {
        type: types.LOGIN_SUCCESS,
        payload: {
            token: token,
            userId: userId,
            login: login,
            apps: apps,
        },
    };
};
export var loginError_AC = function (error) {
    return {
        type: types.LOGIN_ERROR,
        payload: {
            error: error,
        },
    };
};
export var authenticating_AC = function () {
    return {
        type: types.AUTHENTICATING,
    };
};
//# sourceMappingURL=auth.js.map